import { render, staticRenderFns } from "./ParametricKnowledgeEditorHeader.vue?vue&type=template&id=c8747276&scoped=true&"
import script from "./ParametricKnowledgeEditorHeader.vue?vue&type=script&lang=js&"
export * from "./ParametricKnowledgeEditorHeader.vue?vue&type=script&lang=js&"
import style0 from "./ParametricKnowledgeEditorHeader.vue?vue&type=style&index=0&id=c8747276&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8747276",
  null
  
)

export default component.exports